
/// <amd-module name="Build/Common/Library/Components/RepoLink" />
import * as Resources from "Build/Common/Library/Resources";
import { ISourceProvider } from "Build/SourceProviders/Common";
import { ISourceProviderService } from 'Build/SourceProviders/SourceProvider';
import * as React from "react";
import { ICancelReason } from "VSS/Core/Util/Promise";
import { format } from "VSS/Core/Util/String";
import { FPSLink } from "VSS/Features/PlatformUI/FPSLink";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Icon } from "VSSUI/Icon";


export interface IRepoLinkProps {
    sourceRepositoryName: string;
    sourceRepositoryUrl: string;
    sourceRepositoryId: string;
    sourceRepositoryType: string;
    includeIcon?: boolean; // default true
}

interface IRepoLinkState {
    repoLink: string;
}

export class RepoLink extends VssComponent<IRepoLinkProps, IRepoLinkState> {
    private _repoIconName: string;
    private _sourceProvider: ISourceProvider;

    constructor(props: IRepoLinkProps, context: IVssComponentContext) {
        super(props, context);

        const sourceProviderService = this.context.pageContext.getService<ISourceProviderService>("ISourceProviderService");
        this._sourceProvider = sourceProviderService.getSourceProvider(this.props.sourceRepositoryType);
        if (props.includeIcon !== false) {
            this._repoIconName = this._sourceProvider ? this._sourceProvider.getRepoIconName() : "";
        }

        this.state = {
            repoLink: ""
        }
    }
    
    public componentDidMount() {
        super.componentDidMount();

        if (this._sourceProvider) {
            this.trackPromise(
                this._sourceProvider.getProjectName(this.props.sourceRepositoryId)
            ).promise.then((projectName: string | null) => 
                this.trackPromise(
                    this._sourceProvider.fetchRepositoryLink({
                        repositoryName: this.props.sourceRepositoryName || this.props.sourceRepositoryId,
                        repositoryUrl: this.props.sourceRepositoryUrl,
                        repositoryId: this.props.sourceRepositoryId
                    }, projectName ? projectName : undefined)
                ).promise
            ).then((link: string) => {
                this.setState({
                    repoLink: link
                })
            }, (error: ICancelReason) => {
                if (!error.isCanceled) {
                    console.log(error);
                }
            });
        }
    }

    public render() {
        const repoName = this.props.sourceRepositoryName || this.props.sourceRepositoryId;
        if (repoName) {
            return (
                <FPSLink className="scroll-hidden flex-row flex-baseline" href={this.state.repoLink} subtle={true} ariaLabel={format(Resources.RepoLabelFormat, repoName)} removeUnderline={true}>
                    <span className="text-ellipsis ">
                        { this.props.includeIcon !== false && <Icon iconName={this._repoIconName} className="pipelines-icon-right-margin" /> }
                        {repoName}
                    </span>
                </FPSLink >
            );
        }

        return <span></span>;
    }
}
